/**
 * Builds the fetchMapLocations payload for a State viewport refresh.
 *
 * The location type stays State, so the routing layer never adds a `coordinates`
 * query parameter to the URL; only the viewport bounds narrow the results.
 *
 * Pure — no side effects, no SDK coupling.
 *
 * @module searchResultsMap/services/stateViewportPayload
 */

import { STATE } from '../constants';

/**
 * @param {object|null} location - Current search location from the store.
 * @param {{ south: number, north: number, west: number, east: number }} bounds
 *   Viewport bounds already clamped to the state.
 * @returns {object|null} fetchMapLocations payload, or null when there is no location.
 */
export default function createStateViewportPayload(location, bounds) {
  if (!location || !bounds) {
    return null;
  }

  return {
    locationType: STATE,
    marketId: location.marketId,
    stateName: location.stateName,
    marketState: location.marketState,
    marketName: location.marketName,
    marketStateName: location.marketStateName,
    geoLocationState: location.geoLocationState,
    city: location.city,
    neighborhoodName: location.neighborhood,
    schoolDistrictName: location.schoolDistrictName,
    schoolDistrictId: location.schoolDistrictId,
    county: location.county,
    zip: location.zip,
    originLatitude: location.originLatitude,
    originLongitude: location.originLongitude,
    minimumLatitude: bounds.south,
    maximumLatitude: bounds.north,
    minimumLongitude: bounds.west,
    maximumLongitude: bounds.east,
  };
}
